import { Key, MutableRefObject } from "react";
import { Option, SelectComponent } from "../../SelectComponent";
import { AsyncListRef } from "../DataTable";
import { Model } from "../../../types";

interface Props {
    onAction: (value: Key, resolve: (value: Model | PromiseLike<Model>) => void) => any;
    options: Option[];
    value?: Key | undefined;

    listRef?: MutableRefObject<AsyncListRef>;
}

const InlineDropdownAction = ({ options, value, onAction, listRef }: Props) => {
    const handleDropdownEvent = (key: Key) => {
        (new Promise<Model>((resolve) => onAction(key, resolve))).then((newData) => {
            listRef.current?.update(newData.id, newData);
        });
    };

    return (
        <SelectComponent buttonProps={{ size: "xs" }} options={options} onChange={handleDropdownEvent} value={value} />
    );
};

export default InlineDropdownAction;